import { j as o } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as i } from "react";
import { I as s } from "../../../../IconBase-CxZyIWw2.js";
const t = i((a, r) => /* @__PURE__ */ o.jsx(
  s,
  {
    ref: r,
    ...a,
    image: (e) => /* @__PURE__ */ o.jsx(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...e,
        children: /* @__PURE__ */ o.jsx(
          "path",
          {
            fill: "currentColor",
            d: "M1 3a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h9a1 1 0 0 0 1-1v-1.882l3.553 1.776A1 1 0 0 0 16 11V5a1 1 0 0 0-1.447-.894L11 5.882V4a1 1 0 0 0-1-1z"
          }
        )
      }
    )
  }
));
t.displayName = "VideoIcon";
export {
  t as VideoIcon,
  t as default
};
//# sourceMappingURL=index.js.map
